import { useMemo } from 'react';
import { useAuthStore } from '../../store/authStore';
import { useEscolaComunicados } from '../../api/hooks/useEscolaComunicados';
import { ComunicadosMuralCore } from '../../components/comunicados/ComunicadosMuralCore';
import type { ComunicadoItem } from '../../components/comunicados/ComunicadosConfig';

export default function ComunicadosMuralEscola() {
  const { escolaId, user } = useAuthStore();
  const { data: comunicados = [], isLoading } = useEscolaComunicados();

  const config = useMemo(
    () => ({
      scope: 'ESCOLA' as const,
      scopeId: escolaId || '',
      branding: {
        tenantName: (user as any)?.escolaNome || 'Escola Municipal',
        tenantBadge: 'Direção & Coordenação Escolar',
        logoUrl: (user as any)?.escolaLogoUrl,
        primaryColor: '#2563eb',
        secondaryColor: '#1d4ed8',
        slogan: 'Educação para o Futuro',
        autoridadeNome: user?.nome,
        autoridadeCargo: 'Direção Escolar',
      },
    }),
    [escolaId, user]
  );

  return (
    <ComunicadosMuralCore
      config={config}
      comunicados={comunicados as unknown as ComunicadoItem[]}
      isLoading={isLoading}
    />
  );
}
